type ArrowIconProps = {
  className?: string;
};

const ArrowIcon = ({ className }: ArrowIconProps) => (
  <svg
    className={className}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7071 5.70711C15.3166 5.31658 14.6834 5.31658 14.2929 5.70711L13.944 6.05603C13.5537 6.4463 13.5534 7.07898 13.9433 7.46961L20.2125 13.75L5.375 13.75C4.82272 13.75 4.375 14.1977 4.375 14.75L4.375 15.25C4.375 15.8023 4.82272 16.25 5.375 16.25L20.2125 16.25L13.9334 22.5179C13.5423 22.9083 13.542 23.542 13.9327 23.9327L14.2929 24.2929C14.6834 24.6834 15.3166 24.6834 15.7071 24.2929L24.2929 15.7071C24.6834 15.3166 24.6834 14.6834 24.2929 14.2929L15.7071 5.70711Z"
      fill="#05AAA0"
    />
  </svg>
);

export default ArrowIcon;
